import axios from "axios";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import useHandleErrors from "../../utils/user.utils";
import { useUser } from "../../utils/userContext";
import useCountryCodes from "../../utils/useCountryCodes";
import useConfiguration from "../../utils/ConfigurationContext";
import UpdateWelcomeKit from '../onboardemployee/updatewelcomekit';

const EmployeeUpdate = () => {
  const { employeeId } = useParams();
  const storedToken = localStorage.getItem("token");
  const handleErrors = useHandleErrors();
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const { countryCodes } = useCountryCodes();
  const config = useConfiguration();
  const [employess, setEmployess] = useState([]);
  const hasFetchedRef = useRef(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const hasFetched = useRef(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const navigate = useNavigate();
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [showWelcomeKitModal, setShowWelcomeKitModal] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [userDetails, setUserDetails] = useState({
    personalInformation: {
      employeeId: "",
      activeFlag: "",
      personalDetails: {
        bank: {
          bankName: "",
          branchName: "",
          branchCode: "",
          accountNumber: "",
          accountType: "",
          swiftCode: "",
        },
        family: {
          fatherName: "",
          motherName: "",
          birthCertificate: "",
          spouseName: "",
          marriageCertificate: "",
          children: "",
          childrenDetails: [],
        },
        education: {
          institutionName: "",
          institutionCode: "",
          institutionType: "",
          qualification: "",
          graduationDate: "",
          grade: "",
        },
        health: {
          medicalConditions: "",
          knownChronicConditions: "",
          knownChronicAllergies: "",
          vaccinationStatus: "",
          vaccinationType: "",
          dateOfLastVaccination: "",
          workRelatedInjuries: "",
          dateOfIncident: "",
          incidentDescription: "",
          doYouHavePersonalDoctor: "",
          doctorName: "",
          doctorContact: "",
          doctorEmail: "",
          hospitalName: "",
          healthCertificate: "",
        },
        additionalInformation: {
          kin: "",
          passport: "",
          passportCopy: "",
          conductCertificates: "",
          referenceDetails: "",
        },
        experience: {
          totalExperience: "",
          employerName: "",
          department: "",
          designation: "",
          managerName: "",
          managerEmail: "",
          startdate: "",
          endDate: "",
          location: "",
        },
        achievements: [
          {
            title: "",
            certificate: "",
            achievementDate: "",
            comments: ""
          },
        ],
        skills: [],
        submittedDocuments: [],
      },
    },
    onboardEmployeeDetails: {
      EmployeeId: "",
      UserId: "",
      Title: "",
      FirstName: "",
      MiddleName: "",
      LastName: "",
      PersonalEmail: "",
      OfficialEmail: "",
      ContactNumber: "",
      AlternateContactNumber: "",
      Department: "",
      Designation: "",
      UserAccessLevel: "",
      EmployeeType: "",
      ManagerEmail: "",
      Gender: "",
      BloodGroup: "",
      NID: "",
      DateOfBirth: "",
      DateOfJoining: "",
      DateOfLeaving: "",
      Religion: "",
      WorkLocation: "",
      BirthPlace: "",
      MaritalStatus: "",
      Citizenship: "",
      NSSF: "",
      Tin: "",
      Spouse: "",
      Children: "",
      Status: "",
      ActiveFlag: "",
      UpdatedBy: "",
      Image: "",
      NoticePeriod: "",
      AddressDetailsList: {
        PermanentAddress: [
          {
            addressOne: "",
            addressTwo: "",
            townCity: "",
            state: "",
            postCode: "",
            countryCode: "",
          },
        ],
        CurrentAddress: [
          {
            addressOne: "",
            addressTwo: "",
            townCity: "",
            state: "",
            postCode: "",
            countryCode: "",
          },
        ],
      },
      getAssetListDetails: [
        {
          AssetId: "",
          CategoryType: "",
          AssignDate: "",
          AssignmentType: "",
          SerialNumber: "",
        },
      ],
    },
  });
  // Consultant Details state for consultants
  const [consultantDetails, setConsultantDetails] = useState({
    agencyName: '',
    paymentType: '',
    currency: '',
    price: '',
    tax: ''
  });

  // Populate consultant details if editing existing consultant
  useEffect(() => {
    if (
      userDetails.onboardEmployeeDetails?.EmployeeType === 'Consultant' &&
      Array.isArray(userDetails.onboardEmployeeDetails.ConsultantDetails) &&
      userDetails.onboardEmployeeDetails.ConsultantDetails.length > 0
    ) {
      setConsultantDetails({
        ...userDetails.onboardEmployeeDetails.ConsultantDetails[0]
      });
    }
  }, [userDetails.onboardEmployeeDetails.EmployeeType, userDetails.onboardEmployeeDetails.ConsultantDetails]);

  // Handle Consultant Details change
  const handleConsultantDetailsChange = (e) => {
    const { name, value } = e.target;
    setConsultantDetails((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Payment Type and Currency as select
  const handleConsultantSelectChange = (field) => (selectedOption) => {
    setConsultantDetails((prev) => ({ ...prev, [field]: selectedOption ? selectedOption.value : '' }));
  };

  const token = localStorage.getItem("token");

  const countryCodesOptions = countryCodes?.map((country) => ({
    value: country.value,
    label: `${country.value} (${country.label})`,
  }));

  const employeeOptions = employess?.map((emp) => ({
    value: emp.OfficialEmail,
    label: `${emp.OfficialEmail}`,
  }));

  const departmentOptions = config?.employeeManagement?.department?.map(
    (department) => ({
      value: department,
      label: department,
    })
  );
  const DesignationOptions = config?.employeeManagement?.designation?.map(
    (designation) => ({
      value: designation,
      label: designation,
    })
  );
  const religionOptions = config?.employeeManagement?.religion?.map(
    (religion) => ({
      value: religion,
      label: religion,
    })
  );

  // const tribeOptions = config?.employeeManagement?.tribe?.map((tribe) => ({
  //   value: tribe,
  //   label: tribe,
  // }));

  const GenderOptions = [
    { value: "", label: "" },
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Not preferred to say", label: "Not preferred to say" },
  ];
  const maritialOptions = [
    { value: "", label: "" },
    { value: "Married", label: "Married" },
    { value: "Single", label: "Single" },
  ];

  useEffect(() => {
    if (!hasFetchedRef.current) {
      fetchEmployess();
      fetchPersonalDetails();
      hasFetchedRef.current = true;
    }
  }, []);


  const fetchEmployess = async () => {
    try {
      const path = "/getEmployeeMasterReport";
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setEmployess(response.data.onboardEmployeeDetails);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        toast.error("Something went wrong. Please try again later.", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const handleWelcomeKitModal = () => {
    setShowWelcomeKitModal(!showWelcomeKitModal);
  };

  // Define your UserAccess options
  const UserAccess = [
    { value: "", label: "" },
    { value: "Admin", label: "Admin" },
    { value: "Super User", label: "Super User" },
    { value: "User", label: "User" },
  ];

  const EmployeeTypes = [
    { value: "", label: "" }, // Empty option
    { value: "Contract", label: "Contract" },
    { value: "Permanent", label: "Permanent" },
    { value: "Expatriate", label: "Expatriate" },
    { value: "2MonthProbation", label: "2-Month Probation" },
    { value: "3MonthProbation", label: "3-Month Probation" },
    { value: "Consultant", label: "Consultant" },
  ];

  const bloodGroupOptions = [
    { value: "", label: "" },
    { value: "A+", label: "A+" },
    { value: "A-", label: "A-" },
    { value: "B+", label: "B+" },
    { value: "B-", label: "B-" },
    { value: "AB+", label: "AB+" },
    { value: "AB-", label: "AB-" },
    { value: "O+", label: "O+" },
    { value: "O-", label: "O-" },
  ];

  // Fetch user details from API
  const fetchPersonalDetails = async () => {
    try {
      const path = `/getPersonalDetails?EmployeeId=${employeeId}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });
      if (response.status === 200) {
        setUserDetails(response.data);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        console.error(
          "There was an error fetching the employee data!",
          error
        );
      }
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;

    hasFetched.current = true;

    axios.get('https://restcountries.com/v3.1/all?fields=name,cca2')
      .then(response => {
        const countries = response.data.map(country => ({
          value: country.cca2,
          label: country.name.common,
        }));
        setCountryOptions(countries);
      })
      .catch(error => {
        console.error('Error fetching countries:', error);
      });
  }, []);


  const handleChange = (e) => {
    const { name, value, dataset } = e.target;
    const index = dataset?.index;

    // Address field handling
    let addressType = null;
    let addressField = null;
    if (name.startsWith('present_')) {
      addressType = 'CurrentAddress';
      addressField = name.replace('present_', '');
    } else if (name.startsWith('permanent_')) {
      addressType = 'PermanentAddress';
      addressField = name.replace('permanent_', '');
    }

    setUserDetails((prevDetails) => {
      // If address field, update only the correct address type
      if (addressType && addressField) {
        return {
          ...prevDetails,
          onboardEmployeeDetails: {
            ...prevDetails.onboardEmployeeDetails,
            AddressDetailsList: {
              ...prevDetails.onboardEmployeeDetails.AddressDetailsList,
              [addressType]: prevDetails.onboardEmployeeDetails.AddressDetailsList[addressType]?.map((address, i) => ({
                ...address,
                [addressField]: value,
              })),
            },
          },
        };
      }
      // ...existing code...
      return {
        ...prevDetails,
        personalInformation: {
          ...prevDetails.personalInformation,
          personalDetails: {
            ...prevDetails.personalInformation.personalDetails,
            bank: {
              ...prevDetails.personalInformation.personalDetails.bank,
              [name]: value,
            },
            family: {
              ...prevDetails.personalInformation.personalDetails.family,
              [name]: value,
            },
            education: {
              ...prevDetails.personalInformation.personalDetails.education,
              [name]: value,
            },
            health: {
              ...prevDetails.personalInformation.personalDetails.health,
              [name]: value,
            },
            additionalInformation: {
              ...prevDetails.personalInformation.personalDetails.additionalInformation,
              [name]: value,
            },
            experience: {
              ...prevDetails.personalInformation.personalDetails.experience,
              [name]: value,
            },
            achievements: prevDetails.personalInformation.personalDetails.achievements?.map(
              (achievement, i) =>
                i === parseInt(index)
                  ? { ...achievement, [name]: value }
                  : achievement
            ),
            skills: Array.isArray(prevDetails.personalInformation.personalDetails.skills)
              ? prevDetails.personalInformation.personalDetails.skills?.map((skill, i) =>
                i === parseInt(index)
                  ? value
                  : skill
              )
              : [],
          },
        },
        onboardEmployeeDetails: {
          ...prevDetails.onboardEmployeeDetails,
          [name]: value,
          contactNumberCode: value,
          altcontactNumberCode: value,
          AddressDetailsList: {
            ...prevDetails.onboardEmployeeDetails.AddressDetailsList,
            PermanentAddress:
              prevDetails.onboardEmployeeDetails.AddressDetailsList.PermanentAddress?.map(
                (address) => ({
                  ...address,
                  [name]: value,
                })
              ),
            CurrentAddress:
              prevDetails.onboardEmployeeDetails.AddressDetailsList.CurrentAddress?.map(
                (address) => ({
                  ...address,
                  [name]: value,
                })
              ),
          },
          getAssetListDetails:
            prevDetails.onboardEmployeeDetails.getAssetListDetails?.map(
              (asset) => ({
                ...asset,
                [name]: value,
              })
            ),
        },
      };
    });
  };

  const handleAchievementFileChange = (e, index) => {
    const file = e.target.files[0];
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      personalInformation: {
        ...prevDetails.personalInformation,
        personalDetails: {
          ...prevDetails.personalInformation.personalDetails,
          achievements: prevDetails.personalInformation.personalDetails.achievements.map(
            (achievement, i) =>
              i === index
                ? { ...achievement, certificateFile: file }
                : achievement
          ),
        },
      },
    }));
  };

  const handleAddSkill = () => {
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      personalInformation: {
        ...prevDetails.personalInformation,
        personalDetails: {
          ...prevDetails.personalInformation.personalDetails,
          skills: [...(prevDetails.personalInformation.personalDetails.skills || []), ''],
        },
      },
    }));
  };

  const handleDeleteSkill = (index) => {
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      personalInformation: {
        ...prevDetails.personalInformation,
        personalDetails: {
          ...prevDetails.personalInformation.personalDetails,
          skills: prevDetails.personalInformation.personalDetails.skills.filter((_, i) => i !== index),
        },
      },
    }));
  };


  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const handleTabChange = () => {
    setFileNames('');
    setFileInputKey(Date.now()); // Reset file input
  };

  const handleChangeDropdown =
    (field, isNestedField = false) =>
      (selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";

        setUserDetails((prevDetails) => ({
          ...prevDetails,
          onboardEmployeeDetails: {
            ...prevDetails.onboardEmployeeDetails,
            [field]: value,
            ...(isNestedField ? { [field]: value } : {}),
          },
        }));
      };
  const handleChangeReligion = handleChangeDropdown("Religion");
  const handleChangeTribe = handleChangeDropdown("WorkLocation");
  const handleChangeMaritalStatus = handleChangeDropdown("MaritalStatus");
  const handleChangeCitizenship = handleChangeDropdown("Citizenship");
  const handleChangeUserAccess = handleChangeDropdown("UserAccessLevel");
  const handleChangeEmployeeType = handleChangeDropdown("EmployeeType");
  const handleContactNumberChange = handleChangeDropdown(
    "contactNumberCode",
    true
  );
  const handleAlternateContactNumberChange = handleChangeDropdown(
    "altcontactNumberCode"
  );
  const handleManagerEmail = handleChangeDropdown("ManagerEmail");
  const handleDepartment = handleChangeDropdown("Department");
  const handleDesignation = handleChangeDropdown("Designation");
  const handleGender = handleChangeDropdown("Gender");
  const handleBloodGroup = handleChangeDropdown("BloodGroup");

  useEffect(() => {
    const preloading = document.getElementById("preloading");
    setTimeout(() => {
      if (preloading) {
        preloading.style.display = "none";
      }
    }, 400);
  }, []);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'sameAsPresentAddress') {
      setUserDetails((prevDetails) => {
        if (checked) {
          // Copy Present Address to Permanent Address
          const presentAddress = prevDetails.onboardEmployeeDetails.AddressDetailsList.CurrentAddress?.[0] || {};
          return {
            ...prevDetails,
            onboardEmployeeDetails: {
              ...prevDetails.onboardEmployeeDetails,
              AddressDetailsList: {
                ...prevDetails.onboardEmployeeDetails.AddressDetailsList,
                PermanentAddress: [
                  {
                    ...presentAddress,
                    sameAsPresentAddress: true,
                  },
                ],
              },
            },
          };
        } else {
          // Uncheck: keep Permanent Address as is, just update the flag
          return {
            ...prevDetails,
            onboardEmployeeDetails: {
              ...prevDetails.onboardEmployeeDetails,
              AddressDetailsList: {
                ...prevDetails.onboardEmployeeDetails.AddressDetailsList,
                PermanentAddress: prevDetails.onboardEmployeeDetails.AddressDetailsList.PermanentAddress?.map((address) => ({
                  ...address,
                  sameAsPresentAddress: false,
                })),
              },
            },
          };
        }
      });
    } else {
      setUserDetails((prevDetails) => ({
        ...prevDetails,
        [name]: checked,
      }));
    }
  };

  const handleExperienceChange = (e) => {
    const { name, value } = e.target;
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      previousEmployer: {
        ...prevDetails.previousEmployer,
        [name]: value,
      },
    }));
  };

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Custom component to hide the clear indicator
  const ClearIndicator = () => null;

  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [contactNumber, setContactNumber] = useState('');

  // Method to handle country code dropdown changes
  const handleCountryCodeChange = (selectedOption) => {
    const countryCode = selectedOption ? selectedOption.value : '';
    setSelectedCountryCode(selectedOption);

    setUserDetails({
      ...userDetails,
      onboardEmployeeDetails: {
        ...userDetails.onboardEmployeeDetails,
        contactNumberCode: countryCode,
      },
    });
  };

  // Method to handle contact number input changes
  const handleContactNumberInputChange = (e) => {
    const newContactNumber = e.target.value;
    setContactNumber(newContactNumber);

    setUserDetails({
      ...userDetails,
      onboardEmployeeDetails: {
        ...userDetails.onboardEmployeeDetails,
        ContactNumber: `${newContactNumber}`,
      },
    });
  };

  const [selectedAltCountryCode, setSelectedAltCountryCode] = useState(null);
  const [altcontactNumberCode, setAlternateContactNumber] = useState('');


  // Method to handle alternate country code dropdown changes
  const handleAlternateCountryCodeChange = (selectedOption) => {
    const countryCode = selectedOption ? selectedOption.value : '';
    setSelectedAltCountryCode(selectedOption);

    setUserDetails({
      ...userDetails,
      onboardEmployeeDetails: {
        ...userDetails.onboardEmployeeDetails,
        altcontactNumberCode: countryCode, // Assuming you have a field for alternate contact number code
      },
    });
  };

  // Method to handle alternate contact number input changes
  const handleAlternateContactNumberInputChange = (e) => {
    const newAlternateContactNumber = e.target.value;
    setAlternateContactNumber(newAlternateContactNumber);

    setUserDetails({
      ...userDetails,
      onboardEmployeeDetails: {
        ...userDetails.onboardEmployeeDetails,
        AlternateContactNumber: `${newAlternateContactNumber}`, // Assuming this is the field for alternate contact number
      },
    });
  };

  const transformToPayload = (userDetails) => {
    const jsonPayload = {
      EmployeeId: userDetails?.onboardEmployeeDetails?.EmployeeId,
      ActiveFlag: userDetails?.personalInformation?.activeFlag,
      PersonalDetails: {
        Bank: {
          BankName:
            userDetails?.personalInformation?.personalDetails?.bank?.bankName,
          BranchName:
            userDetails?.personalInformation?.personalDetails?.bank?.branchName,
          BranchCode:
            userDetails?.personalInformation?.personalDetails?.bank?.branchCode,
          AccountNumber:
            userDetails?.personalInformation?.personalDetails?.bank
              ?.accountNumber,
          AccountType:
            userDetails?.personalInformation?.personalDetails?.bank
              ?.accountType,
          SwiftCode:
            userDetails?.personalInformation?.personalDetails?.bank?.swiftCode,
        },
        Family: {
          FatherName:
            userDetails?.personalInformation?.personalDetails?.family
              ?.fatherName,
          MotherName:
            userDetails?.personalInformation?.personalDetails?.family
              ?.motherName,
          SpouseName:
            userDetails?.personalInformation?.personalDetails?.family
              ?.spouseName,
          Children: hasChildren === "Yes" ? "Yes" : "No",
          ChildrenDetails:
            hasChildren === "Yes"
              ? childrenDetails.map((child) => ({
                ChildrenName: child.ChildrenName,
                Age: child.Age,
              }))
              : [],
        },
        Education: {
          InstitutionName:
            userDetails?.personalInformation?.personalDetails?.education
              ?.institutionName,
          InstitutionCode:
            userDetails?.personalInformation?.personalDetails?.education
              ?.institutionCode,
          InstitutionType:
            userDetails?.personalInformation?.personalDetails?.education
              ?.institutionType,
          Qualification:
            userDetails?.personalInformation?.personalDetails?.education
              ?.qualification,
          GraduationDate:
            userDetails?.personalInformation?.personalDetails?.education
              ?.graduationDate,
          Grade:
            userDetails?.personalInformation?.personalDetails?.education?.grade,
        },
        Experience: {
          totalExperience:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.totalExperience,
          employerName:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.employerName,
          department:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.department,
          designation:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.designation,
          managerName:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.managerName,
          managerEmail:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.managerEmail,
          startdate:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.startdate,
          endDate:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.endDate,
          location:
            userDetails?.personalInformation?.personalDetails?.experience
              ?.location,
        },
        Achievements: userDetails?.personalInformation?.personalDetails?.achievements?.map((achievement) => ({
          Title: achievement.title,
          AchievementDate: achievement.achievementDate,
          Comments: achievement.comments,
          Certificate: achievement.certificate,
        })),
        Skills: userDetails?.personalInformation?.personalDetails?.skills,

        Health: {
          MedicalConditions:
            userDetails?.personalInformation?.personalDetails?.health
              ?.medicalConditions,
          KnownChronicConditions:
            userDetails?.personalInformation?.personalDetails?.health
              ?.knownChronicConditions,
          KnownChronicAllergies:
            userDetails?.personalInformation?.personalDetails?.health
              ?.knownChronicAllergies,
          VaccinationStatus:
            userDetails?.personalInformation?.personalDetails?.health
              ?.vaccinationStatus,
          VaccinationType:
            userDetails?.personalInformation?.personalDetails?.health
              ?.vaccinationType,
          DateOfLastVaccination:
            userDetails?.personalInformation?.personalDetails?.health
              ?.dateOfLastVaccination,
          WorkRelatedInjuries:
            userDetails?.personalInformation?.personalDetails?.health
              ?.workRelatedInjuries,
          DateOfIncident:
            userDetails?.personalInformation?.personalDetails?.health
              ?.dateOfIncident,
          IncidentDescription:
            userDetails?.personalInformation?.personalDetails?.health
              ?.incidentDescription,
          DoYouHavePersonalDoctor:
            userDetails?.personalInformation?.personalDetails?.health
              ?.doYouHavePersonalDoctor,
          DoctorName:
            userDetails?.personalInformation?.personalDetails?.health
              ?.doctorName,
          DoctorContact:
            userDetails?.personalInformation?.personalDetails?.health
              ?.doctorContact,
          DoctorEmail:
            userDetails?.personalInformation?.personalDetails?.health
              ?.doctorEmail,
          HospitalName:
            userDetails?.personalInformation?.personalDetails?.health
              ?.hospitalName,
        },
        AdditionalInformation: {
          Kin: userDetails?.personalInformation?.personalDetails
            ?.additionalInformation?.kin,
          Passport:
            userDetails?.personalInformation?.personalDetails
              ?.additionalInformation?.passport,
          ReferenceDetails:
            userDetails?.personalInformation?.personalDetails
              ?.additionalInformation?.referenceDetails,
        },
      },
    };

    const BasicDetails = {
      EmployeeId: userDetails.onboardEmployeeDetails.EmployeeId,
      Title: userDetails.onboardEmployeeDetails.Title,
      FirstName: userDetails.onboardEmployeeDetails.FirstName,
      MiddleName: userDetails.onboardEmployeeDetails.MiddleName,
      LastName: userDetails.onboardEmployeeDetails.LastName,
      PersonalEmail: userDetails.onboardEmployeeDetails.PersonalEmail,
      OfficialEmail: userDetails.onboardEmployeeDetails.OfficialEmail,
      //ContactNumber: userDetails.onboardEmployeeDetails.ContactNumber,
      ContactNumber: selectedCountryCode
        ? `${selectedCountryCode?.value?.split('-')[0]} ${contactNumber}` // Concatenate country code and contact number
        : contactNumber,
      // AlternateContactNumber:
      //   userDetails.onboardEmployeeDetails.AlternateContactNumber,
      AlternateContactNumber: selectedAltCountryCode
        ? `${selectedAltCountryCode?.value?.split('-')[0]} ${altcontactNumberCode}` // Concatenate country code and contact number
        : altcontactNumberCode,
      Department: userDetails.onboardEmployeeDetails.Department,
      Designation: userDetails.onboardEmployeeDetails.Designation,
      UserAccessLevel: userDetails.onboardEmployeeDetails.UserAccessLevel,
      EmployeeType: userDetails.onboardEmployeeDetails.EmployeeType,
      ManagerEmail: userDetails.onboardEmployeeDetails.ManagerEmail,
      Gender: userDetails.onboardEmployeeDetails.Gender,
      BloodGroup: userDetails.onboardEmployeeDetails.BloodGroup,
      NID: userDetails.onboardEmployeeDetails.NID,
      DateOfBirth: userDetails.onboardEmployeeDetails.DateOfBirth,
      DateOfJoining: userDetails.onboardEmployeeDetails.DateOfJoining,
      DateOfLeaving: userDetails.onboardEmployeeDetails.DateOfLeaving,
      Religion: userDetails.onboardEmployeeDetails.Religion,
      WorkLocation: userDetails.onboardEmployeeDetails.WorkLocation,
      BirthPlace: userDetails.onboardEmployeeDetails.BirthPlace,
      MaritalStatus: userDetails.onboardEmployeeDetails.MaritalStatus,
      CitizenShip: userDetails.onboardEmployeeDetails.Citizenship,
      NSSF: userDetails.onboardEmployeeDetails.NSSF,
      Tin: userDetails.onboardEmployeeDetails.Tin,
      NoticePeriod: userDetails.onboardEmployeeDetails.noticePeriod,
      Children: userDetails.onboardEmployeeDetails.Children,
      Status: userDetails.onboardEmployeeDetails.Status,
      ActiveFlag: userDetails.onboardEmployeeDetails.ActiveFlag,
      UpdatedBy: user?.EmployeeId,
      AddressDetailsList: {
        PermanentAddress:
          userDetails.onboardEmployeeDetails.AddressDetailsList.PermanentAddress?.map(
            (address) => ({
              AddressOne: address.addressOne,
              AddressTwo: address.addressTwo,
              TownCity: address.townCity,
              State: address.state,
              PostCode: address.postCode,
              CountryCode: address.countryCode,
            })
          ),
        CurrentAddress:
          userDetails.onboardEmployeeDetails.AddressDetailsList.CurrentAddress?.map(
            (address) => ({
              AddressOne: address.addressOne,
              AddressTwo: address.addressTwo,
              TownCity: address.townCity,
              State: address.state,
              PostCode: address.postCode,
              CountryCode: address.countryCode,
            })
          ),
      },
    };

    const consultantPayload = {
      EmployeeId: userDetails.onboardEmployeeDetails.EmployeeId,
      AgencyName: consultantDetails.agencyName,
      PaymentType: consultantDetails.paymentType,
      Currency: consultantDetails.currency,
      Price: consultantDetails.price,
      Tax: consultantDetails.tax
    };

    return { jsonPayload, BasicDetails, consultantPayload };
  };

  const validateFields = () => {
    const requiredFields = [
      { name: "ContactNumber", label: "Contact Number" },
      { name: "UserId", label: "User ID" },
      { name: "ManagerEmail", label: "Manager Email" },
      { name: "Department", label: "Department" },
      { name: "Designation", label: "Designation" },
      { name: "DateOfJoining", label: "Date of Joining" },
      { name: "Gender", label: "Gender" },
      { name: "PersonalEmail", label: "Personal Email" },
      { name: "DateOfBirth", label: "Date of Birth" },
      { name: "BloodGroup", label: "Blood Group" },
      { name: "NID", label: "NID" },
      { name: "Religion", label: "Religion" },
      { name: "MaritalStatus", label: "Marital Status" },
      { name: "Citizenship", label: "Citizenship" },
      { name: "NSSF", label: "NSSF" },
    ];

    const dateFields = ["DateOfJoining", "DateOfBirth",]; // Add more date fields if needed
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD format

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const managerEmail = userDetails?.experience?.ManagerEmail;
    const personalEmail = userDetails?.onboardEmployeeDetails?.PersonalEmail;
    const doctorEmail = userDetails?.health?.doctorEmail || '';

    if (managerEmail && !emailPattern.test(managerEmail)) {
      toast.error("Please enter a valid Manager Email.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    if (!emailPattern.test(personalEmail)) {
      toast.error("Please enter a valid Personal Email.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    if (doctorEmail && !emailPattern.test(doctorEmail)) {
      toast.error("Please enter a valid Doctor Email.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return false;
    }

    for (let field of requiredFields) {
      if (!userDetails.onboardEmployeeDetails?.[field.name]) {
        toast.error(`${field.label} is required.`, {
          position: toast.POSITION.TOP_CENTER,
        });
        return false;
      }
    }

    for (let dateField of dateFields) {
      const dateValue = moment(userDetails.onboardEmployeeDetails?.[dateField]).format("YYYY-MM-DD")
      console.log("dateValue", dateValue)
      if (dateValue && !dateRegex.test(dateValue)) {
        toast.error(`${dateField.replace(/([A-Z])/g, " $1")} should be in YYYY-MM-DD format.`, {
          position: toast.POSITION.TOP_CENTER,
        });
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateFields()) {
      setLoading(false);
      return;
    }

    setLoading(true);
    const formData = new FormData();

    // Add ConsultantDetails to payload if Consultant
    let userDetailsWithConsultant = { ...userDetails };
    if (userDetailsWithConsultant.onboardEmployeeDetails?.EmployeeType === 'Consultant') {
      userDetailsWithConsultant = {
        ...userDetailsWithConsultant,
        onboardEmployeeDetails: {
          ...userDetailsWithConsultant.onboardEmployeeDetails,
          ConsultantDetails: [consultantDetails]
        }
      };
    }
    const { jsonPayload, BasicDetails, consultantPayload } = transformToPayload(userDetailsWithConsultant);
    console.log("jsonPayload", jsonPayload)

    formData.append("jsonPayload", JSON.stringify(jsonPayload));
    formData.append("BasicDetails", JSON.stringify(BasicDetails));
    formData.append("consultantPayload", JSON.stringify(consultantPayload));
    formData.append("BirthCertificate", files.birthCertificateFile);
    formData.append("MarriageCertificate", files.marriageCertificateFile);
    formData.append("PassportCopy", files.passportCopyFile);
    formData.append("ConductCertificates", files.conductCertificatesFile);
    formData.append("HealthCertificate", files.healthCertificateFile);
    uploadedFiles.forEach((file, index) => {
      formData.append(`submittedDocuments`, file);
    });
    userDetails?.personalInformation?.personalDetails?.achievements?.forEach((achievement, index) => {
      if (achievement.certificateFile) {
        formData.append(`SkillDocuments`, achievement.certificateFile);
      }
    });
    formData.append("Image", selectedImageFile ? selectedImageFile : userDetails?.onboardEmployeeDetails?.Image);

    try {
      const path = `/personalDetails`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, formData, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("Data Updated Successfully!.", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        console.error("There was an error fetching the employee data!", error);
      }
    } finally {
      setLoading(false);
    }
  };

  // Payslips

  const monthNames = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december",
  ];

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  // const [fileName, setFileName] = useState("Choose file");
  const [fileNames, setFileNames] = useState({
    birthCertificate: 'Choose file',
    marriageCertificate: 'Choose file',
    passportCopy: 'Choose file',
    conductCertificates: 'Choose file',
    healthCertificate: 'Choose file'
  });
  const [payslips, setPayslips] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);

  const [files, setFiles] = useState({
    birthCertificateFile: null,
    marriageCertificateFile: null,
    passportCopyFile: null,
    conductCertificatesFile: null,
    healthCertificateFile: null,
  });

  const handleIndividualChanage = (event) => {
    const { id, files: selectedFiles } = event.target;
    const file = selectedFiles[0];

    if (file) {
      // Dynamically update file states and file names
      setFiles((prevFiles) => ({
        ...prevFiles,
        [`${id}File`]: file,  // e.g., birthCertificateFile, marriageCertificateFile
      }));
      setFileNames((prevFileNames) => ({
        ...prevFileNames,
        [id]: file.name,  // e.g., birthCertificate, marriageCertificate
      }));
    } else {
      setFileNames((prevFileNames) => ({
        ...prevFileNames,
        [id]: 'Choose file',
      }));
    }
  };


  useEffect(() => {
    const button = document.getElementById("fetch-documents-btn");
    const handlePayslipClick = () => fetchPayslips(selectedYear);

    button.addEventListener("click", handlePayslipClick);
    return () => {
      button.removeEventListener("click", handlePayslipClick);
    };
  }, [selectedYear]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const numberOfYearsToShow = 10; // Adjust this number as per your requirement
    if (years.length === 0) {
      const yearsToShow = Array.from(
        { length: numberOfYearsToShow },
        (_, index) => currentYear - index
      );
      setYears(yearsToShow.reverse()); // Reverse to show from oldest to newest
    }
  }, [years]);

  const fetchPayslips = async (year) => {
    try {
      const path = `/paySlips?employeeId=${employeeId}&year=${year}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });
      if (response.status == 200) {
        const allDocuments = response.data;
        setDocuments(allDocuments.filter((doc) => doc.Path.includes(year)));
      } else {
        setDocuments([]);
        handleErrors(response);
      }
    } catch (error) {
      if (error.response.status === 404) {
        // Handle 404 status code separately
        setDocuments([]);
      } else {
        handleErrors(error.response);
      }
      setDocuments([]);
    }
  };

  const handleFileChange = (event) => {
    const { id, files } = event.target;
    const file = files[0];
    if (file) {
      setSelectedFile(file);
      setFileNames((prevFileNames) => ({
        ...prevFileNames,
        [id]: file.name,
      }));
    } else {
      setFileNames((prevFileNames) => ({
        ...prevFileNames,
        [id]: "Choose file",
      }));
    }
  };
  const handleDocumentsUpload = () => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const binaryData = e.target.result;
        setUploadedFiles((prevFiles) => [...prevFiles, selectedFile]);
        setFileNames({
          birthCertificate: "Choose file",
          marriageCertificate: "Choose file",
          // Reset other file inputs here
        });
      };
      reader.readAsBinaryString(selectedFile);
    }
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!selectedFile) {
      toast.error("Please select a file");
      return;
    }

    const year = selectedDate.getFullYear();
    const month = monthNames[selectedDate.getMonth()]; // Get the month name from the array

    const formData = new FormData();
    formData.append("uploadDocuments", selectedFile);

    try {
      const path = `/upload/Payslip/${year}/${month}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, formData, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("Payslip uploaded successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        console.error("There was an error fetching the employee data!", error);
      }
    }
  };

  // Insukrance

  const [insDocuments, setInsDocuments] = useState([]);
  const currentYear = new Date().getFullYear();
  const [inSyears, inSsetYears] = useState([]);
  const [availableInsuranceCount, setAvailableInsuranceCount] = useState(0);

  useEffect(() => {
    const button = document.getElementById("fetch-documents-btn");
    const handleInsuranceClick = () => fetchInsDocuments(currentYear);

    button.addEventListener("click", handleInsuranceClick);
    return () => {
      button.removeEventListener("click", handleInsuranceClick);
    };
  }, [currentYear]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const numberOfYearsToShow = 10; // Adjust this number as per your requirement
    if (inSyears.length === 0) {
      const yearsToShow = Array.from(
        { length: numberOfYearsToShow },
        (_, index) => currentYear - index
      );
      inSsetYears(yearsToShow.reverse()); // Reverse to show from oldest to newest
    }
  }, [inSyears]);

  const fetchInsDocuments = async (year) => {
    try {
      const path = `/documentReports?employeeId=${employeeId}&documentType=Insurance&year=${year}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });
      if (response.status === 200) {
        setInsDocuments(response.data);
        setAvailableInsuranceCount(response.data.length);
      } else {
        console.error("Failed to fetch insurance documents");
        setInsDocuments([]);
        setAvailableInsuranceCount(0);
        handleErrors(response);
      }
    } catch (error) {
      if (error.response.status === 404) {
        // Handle 404 status code separately
        setInsDocuments([]);
      } else {
        handleErrors(error.response);
      }
    }
  };

  const handleUploadInsurance = async () => {
    try {
      if (!selectedFile) {
        toast.error("Please select a file.", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      const formData = new FormData();
      const year = selectedDate.getFullYear();
      formData.append("file", selectedFile);
      const path = `/uploadDocument/Insurance/${year}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, formData, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("File uploaded successfully!.", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        console.error("There was an error fetching the employee data!", error);
      }
    }
  };

  // Tax

  const [taxDocuments, setTaxDocuments] = useState([]);
  // const currentYear = new Date().getFullYear();
  const [taxYears, taxsetYears] = useState([]);
  const [availableTaxuranceCount, setAvailableTaxuranceCount] = useState(0);

  useEffect(() => {
    const button = document.getElementById("fetch-documents-btn");
    const handleTaxClick = () => fetchTaxDocuments(currentYear);

    button.addEventListener("click", handleTaxClick);
    return () => {
      button.removeEventListener("click", handleTaxClick);
    };
  }, [currentYear]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const numberOfYearsToShow = 10; // Adjust this number as per your requirement
    if (inSyears.length === 0) {
      const yearsToShow = Array.from(
        { length: numberOfYearsToShow },
        (_, index) => currentYear - index
      );
      inSsetYears(yearsToShow.reverse()); // Reverse to show from oldest to newest
    }
  }, [inSyears]);

  const fetchTaxDocuments = async (year) => {
    try {
      const path = `/documentReports?employeeId=${employeeId}&documentType=Tax&year=${year}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });
      if (response.status === 200) {
        setTaxDocuments(response.data);
        setAvailableTaxuranceCount(response.data.length);
      } else {
        console.error("Failed to fetch insurance documents");
        setTaxDocuments([]);
        setAvailableTaxuranceCount(0);
      }
    } catch (error) {
      if (error.response.status === 404) {
        // Handle 404 status code separately
        setDocuments([]);
      } else {
        handleErrors(error.response);
      }
      console.error("Error fetching insurance documents:", error);
      setTaxDocuments([]);
      setAvailableTaxuranceCount(0);
    }
  };

  const handleUploadTax = async () => {
    try {
      if (!selectedFile) {
        toast.error("Please select a file.", {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      const formData = new FormData();
      const year = selectedDate.getFullYear();
      formData.append("file", selectedFile);
      const path = `/uploadDocument/Tax/${year}`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.post(URL, formData, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("File uploaded successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        console.error("There was an error fetching the employee data!", error);
      }
    }
  };

  const [requestedDate, setRequestedDate] = useState(""); // Initialize with empty string or default value
  const [advanceRequests, setAdvanceRequests] = useState([]);
  const [pendingRequests, setPendingRequests] = useState([]);

  useEffect(() => {
    const button = document.getElementById("fetch-documents-btn");
    const handleAdvanceRequestClick = () =>
      fetchAdvanceRequests(employeeId, requestedDate);

    button.addEventListener("click", handleAdvanceRequestClick);
    return () => {
      button.removeEventListener("click", handleAdvanceRequestClick);
    };
  }, [employeeId, requestedDate]);

  const fetchAdvanceRequests = async (employeeId, requestedDate) => {
    console.log("requestedDate", requestedDate)
    try {
      const path = `/getAdvanceSalaryRequests`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.get(URL, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
        params: {
          employeeId,
          requestedDate,
        },
      });
      if (response.status === 200) {
        const allRequests = response.data;
        setAdvanceRequests(allRequests);
        const pendingRequests = allRequests.filter(
          (request) => request.status?.toLowerCase() === "pending"
        );
        setPendingRequests(pendingRequests);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response.status === 404) {
        // Handle 404 status code separately
        setAdvanceRequests([]);
      } else {
        handleErrors(error.response);
      }
    }
  };

  const [status, setStatus] = useState("");
  const [comments, setComments] = useState("");

  const handleUpdate = async (request) => {
    if (!status) {
      toast.error("Please select Approve or Reject");
      return;
    }

    if (status === "Rejected" && !comments) {
      toast.error("Please provide a comment for rejection");
      return;
    }

    const payload = {
      employeeId: employeeId,
      RequestedDate: moment(request?.requestedDate).format("YYYY-MM-DD"),
      status: status,
      comments: comments,
      updatedBy: user?.EmployeeId,
    };

    try {
      const path = `/updateAdvanceSalaryRequest`;
      const URL = process.env.REACT_APP_BE_URL + path;
      const response = await axios.put(URL, payload, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });
      if (response.status === 200) {
        setStatus("")
        setComments("")
        toast.success("Advance salary request updated successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchAdvanceRequests(employeeId, requestedDate);
      } else {
        handleErrors(response);
      }
    } catch (error) {
      if (error.response) {
        handleErrors(error.response);
      } else {
        console.error("There was an error fetching the employee data!", error);
      }
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString)
      .toLocaleDateString("en-GB", options)
      .replace(/\//g, "-");
  };

  const [hasChildren, setHasChildren] = useState(
    userDetails?.personalInformation?.personalDetails?.family?.children
      ? "Yes"
      : "No"
  );
  const [childrenDetails, setChildrenDetails] = useState(
    userDetails?.personalInformation?.personalDetails?.family
      ?.childrenDetails || []
  );

  // Handle dropdown change for children status
  const handleDropdownChange = (e) => {
    const value = e.target.value;
    setHasChildren(value);
    if (value === "No") {
      setChildrenDetails([]);
    } else if (value === "Yes" && childrenDetails.length === 0) {
      setChildrenDetails([{ ChildrenName: "", Age: "" }]);
    }
  };

  // Handle changes to children details
  const handleChildrenChange = (index, e) => {
    const { name, value } = e.target;
    setChildrenDetails((prev) => {
      const updatedDetails = [...prev];
      updatedDetails[index] = { ...updatedDetails[index], [name]: value };
      return updatedDetails;
    });
  };

  // Add a new child entry
  const addChild = () => {
    setChildrenDetails((prev) => [...prev, { ChildrenName: "", Age: "" }]);
  };

  // Remove a child entry
  const removeChild = (index) => {
    setChildrenDetails((prev) => prev.filter((_, i) => i !== index));
  };

  const renderDocumentLink = (documentPath, label) => {
    const fileName = documentPath ? documentPath.split('/').pop() : '';
    return (
      <div className="form-group col-md-6">
        <small className="form-text text-muted">{label}</small>
        <a href={documentPath} className="d-block mt-2">
          {fileName}
        </a>
      </div>
    );
  };

  // const handleDocumentsUpload = () => {
  //   if (selectedFile) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const binaryData = e.target.result;
  //       setUploadedFiles((prevFiles) => [...prevFiles, selectedFile]);
  //       setFileName("Choose a file");
  //     };
  //     reader.readAsBinaryString(selectedFile);
  //   }
  // };

  const handleDelete = (fileIndex) => {
    setUploadedFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== fileIndex)
    );

  };

  const handleAddAchievement = () => {
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      personalInformation: {
        ...prevDetails.personalInformation,
        personalDetails: {
          ...prevDetails.personalInformation.personalDetails,
          achievements: [
            ...(prevDetails.personalInformation.personalDetails.achievements || []),
            { title: '', achievementDate: '', comments: '', certificate: '' }, // Add a new empty achievement
          ],
        },
      },
    }));
  };

  const handleDeleteAchievement = (index) => {
    setUserDetails((prevDetails) => ({
      ...prevDetails,
      personalInformation: {
        ...prevDetails.personalInformation,
        personalDetails: {
          ...prevDetails.personalInformation.personalDetails,
          achievements: prevDetails.personalInformation.personalDetails.achievements.filter(
            (_, i) => i !== index // Remove the achievement at the specified index
          ),
        },
      },
    }));
  };

  const handleKeyPress = (event) => {
    const charCode = event.charCode || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };
  const handleCancel = (event) => {
    navigate("/Employees");
  };
  const handlePayslipCancel = () => {
    setStatus("")
    setComments("")
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
        setSelectedImageFile(file);
        const reader = new FileReader();
        reader.onload = () => {
          setImageSrc(reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        toast.error('Only .jpg, .png, .jpeg files are allowed.', {
          position: toast.POSITION.TOP_CENTER,
        });
        setSelectedImageFile(null);
        setImageSrc('');
      }
    }
  };

  return (
    <div>
      {loading && (
        <div id="preloading">
          <span className="loader"></span>
        </div>
      )}
      <ToastContainer />
      <div class="content-page">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col">
              <h3 class="title mb-2">Update Information</h3>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-secondary mt-lg-0 mt-4"
                type="button"
                onClick={handleWelcomeKitModal}
              >
                <i className="ri-gift-line"></i> Update Welcome Kit
              </button>
            </div>


            <div className="col-auto">

              <button
                id="fetch-documents-btn"
                className="btn btn-primary mt-lg-0 mt-4"
                onClick={toggleSidebar}
              >
                <i className="ri-cash-line"></i> Employee Payroll
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="container-fluid row-rounded">
                    <div class="row px-2 py-0">
                      <div class="input-group mb-0">
                        <input
                          disabled
                          type="search"
                          class="form-control search-input"
                          value={userDetails.onboardEmployeeDetails?.EmployeeId}
                        />
                        <div class="input-group-append">
                          <button
                            class="btn btn-primary"
                            type="button"
                            title="Search"
                            rel="tooltip"
                          >
                            <i class="ri-user-search-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="user-info">
                    <div className="profile-detail">
                      <div className="user-profile-pic">
                        <img
                          src={imageSrc ? imageSrc : userDetails.onboardEmployeeDetails?.Image}
                          className="img-fluid"
                          alt="Profile"
                        />
                      </div>

                      <label
                        htmlFor="file"
                        className="profile-pic-upload"
                        title="Upload Photo"
                      >
                        <i className="ri-image-add-line"></i>
                        <input
                          type="file"
                          id="file"
                          style={{ display: "none" }}
                          name="image"
                          accept="image/jpeg,image/jpg,image/png"
                          onChange={handleImageChange}
                        />
                      </label>
                    </div>
                  </div>
                  <small className="form-text text-muted text-center mt-4">
                    Only .jpg .png .jpeg allowed.
                  </small>
                  {/* <div className="text-center mt-3 mb-4">
                    <h6>
                      {userDetails.onboardEmployeeDetails?.FirstName}{" "}
                      {userDetails.onboardEmployeeDetails?.MiddleName}
                      {userDetails.onboardEmployeeDetails?.LastName}
                    </h6>
                  </div> */}
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label htmlFor="firstName" className="required">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        name="FirstName"
                        value={userDetails.onboardEmployeeDetails?.FirstName || ""}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group col-md-12">
                      <label htmlFor="middleName">Middle Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="middleName"
                        name="MiddleName"
                        value={userDetails.onboardEmployeeDetails?.MiddleName || ""}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="form-group col-md-12">
                      <label htmlFor="lastName" className="required">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        name="LastName"
                        value={userDetails.onboardEmployeeDetails?.LastName || ""}
                        onChange={handleChange}
                      />
                    </div>
                  </div>



                  <div className="row mt-3">
                    <div className="form-group col-md-12">
                      <label htmlFor="oemail" className="required">
                        Official Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="oemail"
                        value={
                          userDetails.onboardEmployeeDetails?.OfficialEmail
                        }
                        onChange={handleChange}
                        disabled
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="useraccess" className="required">
                        User Access
                      </label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="UserAccessLevel"
                        value={
                          UserAccess.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails
                                ?.UserAccessLevel
                          ) || null
                        }
                        onChange={handleChangeUserAccess}
                        options={UserAccess}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Employment Type</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="EmployeeType"
                        value={
                          EmployeeTypes.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.EmployeeType
                          ) || null
                        }
                        onChange={handleChangeEmployeeType}
                        options={EmployeeTypes}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label htmlFor="mobno" className="required">
                        Contact Number
                      </label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="contactNumberCode"
                            // value={
                            //   countryCodesOptions.find(
                            //     (option) =>
                            //       option.value ===
                            //       userDetails.onboardEmployeeDetails
                            //         ?.contactNumberCode
                            //   ) || null
                            // }
                            value={
                              countryCodesOptions.find((option) => `${option.value}-${countryCodesOptions.indexOf(option)}` === userDetails.onboardEmployeeDetails?.contactNumberCode) || null
                            }
                            onChange={handleCountryCodeChange}
                            // options={countryCodesOptions}
                            options={countryCodesOptions.map((option, index) => ({
                              ...option,
                              value: `${option.value}-${index}`, // Add the index to make the value unique
                            }))}
                            components={{ ClearIndicator }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, zIndex: 1 }),
                            }}
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="ContactNumber"
                          value={
                            userDetails.onboardEmployeeDetails?.ContactNumber
                          }
                          onChange={handleContactNumberInputChange}
                          onKeyPress={handleKeyPress}
                        />
                        <div className="input-group-append">
                          <button
                            className="btn btn-secondary"
                            title="Add Alternate Contact"
                            type="button"
                            data-toggle="collapse"
                            data-target="#altContactNumber"
                          >
                            <i className="ri-add-circle-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      className="form-group col-md-12 collapse show"
                      id="altContactNumber"
                    >
                      <label htmlFor="altconno">Alternate Contact</label>
                      <div className="input-group">
                        <div className="input-group-prepend">
                          <Select
                            className="react-select-container"
                            classNamePrefix="react-select"
                            name="altcontactNumberCode"
                            // value={
                            //   countryCodesOptions.find(
                            //     (option) =>
                            //       option.value ===
                            //       userDetails.onboardEmployeeDetails
                            //         ?.altcontactNumberCode
                            //   ) || null
                            // }
                            value={
                              countryCodesOptions.find((option) => `${option.value}-${countryCodesOptions.indexOf(option)}` === userDetails.onboardEmployeeDetails?.altcontactNumberCode) || null}
                            onChange={handleAlternateCountryCodeChange}
                            // options={countryCodesOptions}
                            options={countryCodesOptions.map((option, index) => ({
                              ...option,
                              value: `${option.value}-${index}`, // Add the index to make the value unique
                            }))}
                            components={{ ClearIndicator }}
                            isClearable
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              control: (base) => ({ ...base, zIndex: 1 }),
                            }}
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          id="altconno"
                          name="AlternateContactNumber"
                          value={
                            userDetails.onboardEmployeeDetails
                              ?.AlternateContactNumber
                          }
                          onChange={handleAlternateContactNumberInputChange}
                          onKeyPress={handleKeyPress}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-8">
              <div class="card mb-4">
                <div class="card-body" id="ORGEmployeeDetails">
                  <h5
                    className="title accordion-title"
                    data-toggle="collapse"
                    data-target="#basicDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Basic
                  </h5>
                  <div
                    className="row collapse show"
                    id="basicDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="form-group col-md-6">
                      <label className="required">User ID</label>
                      <input
                        type="text"
                        className="form-control"
                        name="UserId"
                        value={userDetails.onboardEmployeeDetails.UserId || ""}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="oemail" className="required">
                        Manager Email
                      </label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="ManagerEmail"
                        value={
                          employeeOptions.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.ManagerEmail
                          ) || null
                        }
                        onChange={handleManagerEmail}
                        options={employeeOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Department</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="Department"
                        value={
                          departmentOptions?.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.Department
                          ) || null
                        }
                        onChange={handleDepartment}
                        options={departmentOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Designation</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="Designation"
                        value={
                          DesignationOptions?.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.Designation
                          ) || null
                        }
                        onChange={handleDesignation}
                        options={DesignationOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Date of Joining</label>
                      <input
                        type="date"
                        className="form-control"
                        name="DateOfJoining"
                        value={moment(
                          userDetails.onboardEmployeeDetails?.DateOfJoining
                        ).format("YYYY-MM-DD")}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Date of Leaving</label>
                      <input
                        type="date"
                        className="form-control"
                        name="DateOfLeaving"
                        value={
                          userDetails.onboardEmployeeDetails?.DateOfLeaving
                            ? moment(userDetails.onboardEmployeeDetails.DateOfLeaving).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={handleChange}
                      />

                    </div>
                    <div className="form-group col-md-6">
                      <label>NoticePeriod</label>
                      <input
                        type="text"
                        className="form-control"
                        name="NoticePeriod"
                        value={userDetails.onboardEmployeeDetails?.noticePeriod}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#personalDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Personal
                  </h5>
                  <div
                    className="row collapse"
                    id="personalDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="form-group col-md-6">
                      <label className="required">Gender</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="Gender"
                        value={
                          GenderOptions.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.Gender
                          ) || null
                        }
                        onChange={handleGender}
                        options={GenderOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Personal Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="PersonalEmail"
                        value={
                          userDetails.onboardEmployeeDetails?.PersonalEmail
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Date of Birth</label>
                      <input
                        type="date"
                        className="form-control"
                        name="DateOfBirth"
                        value={moment(
                          userDetails.onboardEmployeeDetails?.DateOfBirth
                        ).format("YYYY-MM-DD")}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Blood Group</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="BloodGroup"
                        value={
                          bloodGroupOptions.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.BloodGroup
                          ) || null
                        }
                        onChange={handleBloodGroup}
                        options={bloodGroupOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">National ID</label>
                      <input
                        type="text"
                        className="form-control"
                        name="NID"
                        value={userDetails.onboardEmployeeDetails?.NID}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Religion</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="Religion"
                        value={
                          religionOptions?.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.Religion
                          ) || null
                        }
                        onChange={handleChangeReligion}
                        options={religionOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          control: (base) => ({ ...base, zIndex: 1 }),
                        }}
                      />
                    </div>
                    {/* <div className="form-group col-md-6">
                      <label>WorkLocation</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="Tribe"
                        value={
                          tribeOptions?.find(
                            (option) =>
                              option.value ===
                              userDetails.onboardEmployeeDetails?.Tribe
                          ) || null
                        }
                        onChange={handleChangeTribe}
                        options={tribeOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div> */}
                    <div className="form-group col-md-6">
                      <label >Work Location</label>
                      <input
                        type="text"
                        className="form-control"
                        name="WorkLocation"
                        value={userDetails.onboardEmployeeDetails?.WorkLocation}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label >Birth Place</label>
                      <input
                        type="text"
                        className="form-control"
                        name="BirthPlace"
                        value={userDetails.onboardEmployeeDetails?.BirthPlace}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Marital Status</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="MaritalStatus"
                        value={
                          maritialOptions.find(
                            (option) =>
                              option.value ===
                              userDetails?.onboardEmployeeDetails?.MaritalStatus
                          ) || null
                        }
                        onChange={handleChangeMaritalStatus}
                        options={maritialOptions}
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label className="required">Citizenship</label>
                      <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        name="Citizenship"
                        // Set the initial value by finding the matching option from countryOptions
                        value={
                          countryOptions.find(
                            (option) =>
                              option.label === userDetails.onboardEmployeeDetails?.Citizenship // Compare the value (ID or code)
                          ) || null
                        }
                        onChange={(selectedOption) =>
                          setUserDetails({
                            ...userDetails,
                            onboardEmployeeDetails: {
                              ...userDetails.onboardEmployeeDetails, // Ensure nested object is spread correctly
                              Citizenship: selectedOption ? selectedOption.label : "", // Update with the selected value
                            },
                          })
                        }
                        options={countryOptions} // List of all available options
                        components={{ ClearIndicator }}
                        isClearable
                        menuPortalTarget={document.body}
                      />

                    </div>

                    <div className="form-group col-md-6">
                      <label className="required">NSSF</label>
                      <input
                        type="text"
                        className="form-control"
                        name="NSSF"
                        value={userDetails.onboardEmployeeDetails?.NSSF}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>TIN</label>
                      <input
                        type="text"
                        className="form-control"
                        name="Tin"
                        value={userDetails.onboardEmployeeDetails?.Tin}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#bankDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Bank
                  </h5>
                  <div
                    className="row collapse"
                    id="bankDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="form-group col-md-6">
                      <label>Bank Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="bankName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.bank?.bankName
                        }
                        onChange={handleChange}
                      ></input>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Branch Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="branchName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.bank?.branchName || ""
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Branch Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="branchCode"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.bank?.branchCode
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Account Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="accountNumber"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.bank?.accountNumber
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Account Type</label>
                      <input
                        type="text"
                        className="form-control"
                        name="accountType"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.bank?.accountType
                        }
                        onChange={handleChange}
                      ></input>
                    </div>
                    <div className="form-group col-md-6">
                      <label>SWIFT/BIC Code</label>
                      <input
                        type="text"
                        className="form-control"
                        name="swiftCode"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.bank?.swiftCode
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <hr />
                  <h5
                    class="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#familyDetails"
                  >
                    <i
                      class="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Family
                  </h5>
                  <div
                    class="row collapse"
                    id="familyDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div class="form-group col-md-6">
                      <label>Father Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="fatherName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.family?.fatherName
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Mother Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="motherName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.family?.motherName
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label class="required">Birth Certificate</label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="birthCertificate"
                            onChange={handleIndividualChanage}
                          />
                          <label
                            class="custom-file-label"
                            for="birthCertificate"
                          >
                            {fileNames.birthCertificate}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label>Spouse Name</label>
                      <input
                        type="text"
                        class="form-control"
                        name="spouseName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.family?.spouseName
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label>Marriage Certificate</label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="marriageCertificate"
                            onChange={handleIndividualChanage}
                          />
                          <label
                            class="custom-file-label"
                            for="marriageCertificate"
                          >
                            {fileNames.marriageCertificate}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label htmlFor="children">Children</label>
                      <select
                        className="form-control"
                        id="children"
                        value={hasChildren}
                        onChange={handleDropdownChange}
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                    {hasChildren === "Yes" &&
                      childrenDetails.map((child, index) => (
                        <>
                          <div key={index} className="form-group col-md-6">
                            <label htmlFor={`childName-${index}`}>
                              Children Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id={`childName-${index}`}
                              name="ChildrenName"
                              value={child.ChildrenName}
                              onChange={(e) => handleChildrenChange(index, e)}
                            />
                          </div>
                          <div key={index} className="form-group col-md-4">
                            <label htmlFor={`childAge-${index}`}>
                              Children Age
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id={`childName-${index}`}
                              name="Age"
                              min="0"
                              value={child.Age}
                              onChange={(e) => handleChildrenChange(index, e)}
                            />
                          </div>
                          {index > 0 && (
                            <div className="form-group col-md-2 d-flex align-items-end">
                              <button
                                className="btn btn-danger"
                                title="Remove Child"
                                type="button"
                                onClick={() => removeChild(index)}
                              >
                                <i className="ri-delete-bin-line"></i>
                              </button>
                            </div>
                          )}
                          {index === 0 && (
                            <div className="form-group col-md-2 d-flex align-items-end">
                              <button
                                className="btn btn-secondary"
                                title="Add Child"
                                type="button"
                                onClick={addChild}
                              >
                                <i className="ri-add-circle-line"></i>
                              </button>
                            </div>
                          )}
                        </>
                      ))}
                  </div>
                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#addressDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Address
                  </h5>
                  <div
                    className="row collapse"
                    id="addressDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="col-lg-6 mt-4">
                      <h6 className="mt-2">Present Address</h6>
                      <div className="row">
                        <div className="form-group col-md-12">
                          <label>Address Line 1</label>
                          <input
                            type="text"
                            className="form-control"
                            name="present_addressOne"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.CurrentAddress[0]
                                ?.addressOne
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Address Line 2</label>
                          <input
                            type="text"
                            className="form-control"
                            name="present_addressTwo"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.CurrentAddress[0]
                                ?.addressTwo
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Town/City</label>
                          <input
                            type="text"
                            className="form-control"
                            name="present_townCity"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.CurrentAddress[0]
                                ?.townCity
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>State</label>
                          <input
                            type="text"
                            className="form-control"
                            name="present_state"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.CurrentAddress[0]?.state
                            }
                            onChange={handleChange}
                          ></input>
                        </div>
                        <div className="form-group col-md-6">
                          <label>Post Code</label>
                          <input
                            type="text"
                            className="form-control"
                            name="present_postCode"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.CurrentAddress[0]
                                ?.postCode
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Country Code</label>
                          <input
                            type="text"
                            className="form-control"
                            name="present_countryCode"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.CurrentAddress[0]
                                ?.countryCode
                            }
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="sameaddress"
                          name="sameAsPresentAddress"
                          checked={
                            userDetails.onboardEmployeeDetails
                              ?.AddressDetailsList?.CurrentAddress[0]
                              ?.sameAsPresentAddress
                          }
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="custom-control-label control-label-1"
                          htmlFor="sameaddress"
                        >
                          Same as Present address
                        </label>
                      </div>
                      <h6 className="mt-2">Permanent Address</h6>
                      <div className="row">
                        <div className="form-group col-md-12">
                          <label>Address Line 1</label>
                          <input
                            type="text"
                            className="form-control"
                            name="permanent_addressOne"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.PermanentAddress[0]
                                ?.addressOne
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Address Line 2</label>
                          <input
                            type="text"
                            className="form-control"
                            name="permanent_addressTwo"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.PermanentAddress[0]
                                ?.addressTwo
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>Town/City</label>
                          <input
                            type="text"
                            className="form-control"
                            name="permanent_townCity"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.PermanentAddress[0]
                                ?.townCity
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-12">
                          <label>State</label>
                          <input
                            type="text"
                            className="form-control"
                            name="permanent_state"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.PermanentAddress[0]?.state
                            }
                            onChange={handleChange}
                          ></input>
                        </div>
                        <div className="form-group col-md-6">
                          <label>Post Code</label>
                          <input
                            type="text"
                            className="form-control"
                            name="permanent_postCode"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.PermanentAddress[0]
                                ?.postCode
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Country Code</label>
                          <input
                            type="text"
                            className="form-control"
                            name="permanent_countryCode"
                            value={
                              userDetails.onboardEmployeeDetails
                                ?.AddressDetailsList?.PermanentAddress[0]
                                ?.countryCode
                            }
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#educationDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Education
                  </h5>
                  <div
                    className="row collapse"
                    id="educationDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="form-group col-md-6">
                      <label>Institution Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="institutionName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.education?.institutionName
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Institution Location</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          name="institutionCode"
                          value={
                            userDetails?.personalInformation?.personalDetails
                              ?.education?.institutionCode
                          }
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Institution Type</label>
                      <input
                        type="text"
                        className="form-control"
                        name="institutionType"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.education?.institutionType
                        }
                        onChange={handleChange}
                      ></input>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Degree/Qualification</label>
                      <input
                        type="text"
                        className="form-control"
                        name="qualification"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.education?.qualification
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Graduation Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="graduationDate"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.education?.graduationDate
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Grade/CGPA</label>
                      <input
                        type="text"
                        className="form-control"
                        name="grade"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.education?.grade
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#workExperienceDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Experience
                  </h5>
                  <div
                    className="row collapse"
                    id="workExperienceDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="col-12">
                      <div className="row">
                        <div className="form-group col-md-6">
                          <label>Total Experience</label>
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              name="totalExperience"
                              value={
                                userDetails?.personalInformation
                                  ?.personalDetails?.experience?.totalExperience
                              }
                              onChange={handleChange}
                              onKeyPress={handleKeyPress}
                            />
                          </div>
                        </div>
                      </div>
                      <h6 className="mt-2">Previous Employer Details</h6>
                      <div className="row">
                        <div className="form-group col-md-6">
                          <input
                            type="text"
                            className="form-control"
                            name="employerName"
                            value={
                              userDetails?.personalInformation?.personalDetails
                                ?.experience?.employerName
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Designation</label>

                          <input
                            type="text"
                            className="form-control"
                            name="designation"
                            value={
                              userDetails?.personalInformation?.personalDetails
                                ?.experience?.designation
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Department</label>
                          <input
                            type="text"
                            className="form-control"
                            name="department"
                            value={
                              userDetails?.personalInformation?.personalDetails
                                ?.experience?.department
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Start Date</label>
                          <div className="input-group">
                            <input
                              type="date"
                              className="form-control"
                              name="startdate"
                              value={userDetails.personalInformation?.personalDetails
                                ?.experience?.startdate ? moment(
                                  userDetails.personalInformation?.personalDetails
                                    ?.experience?.startdate
                                ).format("YYYY-MM-DD") : ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-6">
                          <label>End Date</label>
                          <div className="input-group">
                            <input
                              type="date"
                              className="form-control"
                              name="endDate"
                              value={userDetails.personalInformation?.personalDetails
                                ?.experience?.endDate ? moment(
                                  userDetails.personalInformation?.personalDetails
                                    ?.experience?.endDate
                                ).format("YYYY-MM-DD") : ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="form-group col-md-6">
                          <label>Manager Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="managerName"
                            value={
                              userDetails.personalInformation.personalDetails
                                .experience?.managerName
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Manager Email</label>
                          <input
                            type="email"
                            className="form-control"
                            name="managerEmail"
                            value={
                              userDetails.personalInformation.personalDetails
                                .experience?.managerEmail
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Location City</label>
                          <input
                            type="text"
                            className="form-control"
                            name="location"
                            value={
                              userDetails.personalInformation.personalDetails
                                .experience?.location
                            }
                            onChange={handleChange}
                          />
                        </div>
                        <div className="form-group col-md-6">
                          <label>Location Region</label>
                          <input
                            type="text"
                            className="form-control"
                            name="locationRegion"
                            value={
                              userDetails?.personalInformation?.personalDetails
                                ?.experience?.locationRegion
                            }
                            onChange={handleExperienceChange}
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#achievementsDetails"
                  >
                    <i className="ri-information-line" title="Fill all required fields"></i>{" "}
                    Achievements
                  </h5>
                  <div
                    className="row collapse"
                    id="achievementsDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="container">
                      {userDetails?.personalInformation?.personalDetails?.achievements?.map(
                        (achievement, index) => (
                          <div className="row mb-3" key={index}>
                            <div className="col-12">
                              <label>Title</label>
                              <input
                                type="text"
                                className="form-control mb-2"
                                name="title"
                                value={achievement.title}
                                data-index={index}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-12">
                              <label>Date</label>
                              <input
                                type="date"
                                className="form-control mb-2"
                                name="achievementDate"
                                value={moment(achievement.achievementDate).format("YYYY-MM-DD")}
                                data-index={index}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-12">
                              <label>Comments</label>
                              <textarea
                                className="form-control mb-2"
                                name="comments"
                                value={achievement.comments}
                                data-index={index}
                                onChange={handleChange}
                              />
                            </div>
                            <div className="col-12">
                              <label>Certificate</label>
                              {achievement.certificate && typeof achievement.certificate === 'string' ? (
                                <div className="mb-2">
                                  <a href={achievement.certificate} target="_blank" rel="noopener noreferrer">
                                    {achievement.certificate.split('/').pop()}
                                  </a>
                                </div>
                              ) : (
                                <input
                                  type="file"
                                  className="form-control-file mb-2"
                                  data-index={index}
                                  onChange={(e) => handleAchievementFileChange(e, index)}
                                />
                              )}
                            </div>
                            <div className="col-12 text-right">
                              <button
                                type="button"
                                className="btn btn-danger mb-3"
                                onClick={() => handleDeleteAchievement(index)}
                              >
                                <i className="ri-delete-bin-6-line"></i>
                              </button>
                            </div>
                          </div>
                        )
                      )}
                      <div className="row">
                        <div className="col-12">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleAddAchievement}
                          >
                            <i className="ri-add-line"></i>Add
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#skillsDetails"
                  >
                    <i className="ri-information-line" title="Fill all required fields"></i>{" "}
                    Skills
                  </h5>
                  <div className="row collapse" id="skillsDetails" data-parent="#ORGEmployeeDetails">
                    <div className="col-12">
                      {userDetails?.personalInformation?.personalDetails?.skills?.map((skill, index) => (
                        <div key={index} className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder={`Skill ${index + 1}`}
                            value={skill}
                            data-index={index}
                            onChange={handleChange}
                          />
                          <div className="input-group-append">
                            <button
                              className="btn btn-danger"
                              type="button"
                              onClick={() => handleDeleteSkill(index)}
                            >
                              <i className="ri-delete-bin-6-line"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleAddSkill}
                      >
                        <i className="fas fa-plus"></i> Add Skill
                      </button>
                    </div>
                  </div>
                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#healthDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Health
                  </h5>
                  <div
                    className="row collapse"
                    id="healthDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="form-group col-md-6">
                      <label>Medical Conditions and Allergies</label>
                      <select
                        className="form-control"
                        name="medicalConditionsin"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.medicalConditionsin
                        }
                        onChange={handleChange}
                      >
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Known Chronic Conditions</label>
                      <input
                        type="text"
                        className="form-control"
                        name="knownChronicConditions"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.knownChronicConditions
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Known Chronic Allergies</label>
                      <input
                        type="text"
                        className="form-control"
                        name="knownChronicAllergies"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.knownChronicAllergies
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Vaccination Status</label>
                      <select
                        className="form-control"
                        name="vaccinationStatus"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.vaccinationStatus
                        }
                        onChange={handleChange}
                      >
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Type of Vaccination</label>
                      <input
                        type="text"
                        className="form-control"
                        name="vaccinationType"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.vaccinationType
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Date of Last Vaccination</label>
                      <input
                        type="date"
                        className="form-control"
                        name="dateOfLastVaccination"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.dateOfLastVaccination
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Work-Related Injuries and Illnesses</label>
                      <select
                        className="form-control"
                        name="workRelatedInjuries"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.workRelatedInjuries
                        }
                        onChange={handleChange}
                      >
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Date of Incident</label>
                      <input
                        type="date"
                        className="form-control"
                        name="dateOfIncident"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.dateOfIncident
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-12 pb-4 border-bottom">
                      <label>Incident Description</label>
                      <textarea
                        rows="2"
                        className="form-control"
                        name="incidentDescription"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.incidentDescription
                        }
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Do you have personal doctor</label>
                      <select
                        className="form-control"
                        name="doYouHavePersonalDoctor"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.doYouHavePersonalDoctor
                        }
                        onChange={handleChange}
                      >
                        <option>Yes</option>
                        <option>No</option>
                      </select>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Doctor Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="doctorName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.doctorName
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Doctor Contact</label>
                      <input
                        type="text"
                        className="form-control"
                        name="doctorContact"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.doctorContact
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Doctor Email</label>
                      <input
                        type="text"
                        className="form-control"
                        name="doctorEmail"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.doctorEmail
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Hospital Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="hospitalName"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.health?.hospitalName
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Health Certificate</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="healthCertificate"
                            onChange={handleIndividualChanage}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="healthCertificate"
                          >
                            {fileNames.healthCertificate}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h5
                    className="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#additionalDetails"
                  >
                    <i
                      className="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Additional Information
                  </h5>
                  <div
                    className="row collapse"
                    id="additionalDetails"
                    data-parent="#ORGEmployeeDetails"
                  >
                    <div className="form-group col-md-6">
                      <label>KIN</label>
                      <input
                        type="text"
                        className="form-control"
                        name="kin"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.additionalInformation?.kin
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Passport Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="passport"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.additionalInformation?.passport
                        }
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Passport Copy</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="passportCopy"
                            onChange={handleIndividualChanage}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="passportCopy"
                          >
                            {fileNames.passportCopy}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Conduct Certificate</label>
                      <div className="input-group">
                        <div className="custom-file">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="conductCertificate"
                            onChange={handleIndividualChanage}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="conductCertificate"
                          >
                            {fileNames.conductCertificate}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group col-md-6">
                      <label>Referees Details/Contact</label>
                      <input
                        type="text"
                        className="form-control"
                        name="referenceDetails"
                        value={
                          userDetails?.personalInformation?.personalDetails
                            ?.additionalInformation?.referenceDetails
                        }
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <hr />
                  <h5
                    class="title accordion-title collapsed"
                    data-toggle="collapse"
                    data-target="#submittedDocumentsDetails"
                  >
                    <i
                      class="ri-information-line"
                      title="Fill all required fields"
                    ></i>{" "}
                    Documents
                  </h5>
                  <div className="col-lg-12 col-md-12">
                    <div className="form-group">
                      <div className="d-flex align-items-center">
                        <div className="custom-file mr-2">
                          <input
                            type="file"
                            className="custom-file-input"
                            id="Document"
                            onChange={handleFileChange}
                          />
                          <label
                            className="custom-file-label"
                            htmlFor="uploadEmpofferletter"
                          >
                            {fileNames.Document}
                          </label>
                        </div>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={handleDocumentsUpload}
                        >
                          Upload
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* Consultant Details Section (editable for Consultant) */}
                  {userDetails.onboardEmployeeDetails?.EmployeeType === 'Consultant' && (
                    <>
                      <h5
                        class="title accordion-title collapsed"
                        data-toggle="collapse"
                        data-target="#paymentDetails"
                      >
                        <i
                          class="ri-information-line"
                          title="Fill all required fields"
                        ></i>{" "}
                        Payment Information
                      </h5>
                      <div className="row collapse show" id="paymentDetails" data-parent="#ORGEmployeeDetails">
                        <div className="card mb-4 w-100">
                          <div className="card-body">
                            <div className="row">
                              <div className="form-group col-md-4">
                                <label>Vendor Name</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="agencyName"
                                  value={consultantDetails.agencyName || ''}
                                  onChange={handleConsultantDetailsChange}
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Payment Type</label>
                                <Select
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  name="paymentType"
                                  value={[
                                    { value: 'Hourly', label: 'Hourly' },
                                    { value: 'Day rate', label: 'Day rate' },
                                    { value: 'Fixed', label: 'Fixed' }
                                  ].find(option => option.value === consultantDetails.paymentType) || null}
                                  onChange={handleConsultantSelectChange('paymentType')}
                                  options={[
                                    { value: 'Hourly', label: 'Hourly' },
                                    { value: 'Day rate', label: 'Day rate' },
                                    { value: 'Fixed', label: 'Fixed' }
                                  ]}
                                  components={{ ClearIndicator }}
                                  isClearable
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    control: base => ({ ...base, zIndex: 1 })
                                  }}
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Currency</label>
                                <Select
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  name="currency"
                                  value={countryOptions.find(option => option.value === consultantDetails.currency) || null}
                                  onChange={selectedOption =>
                                    setConsultantDetails(prev => ({
                                      ...prev,
                                      currency: selectedOption ? selectedOption.value : '',
                                      currencySymbol: selectedOption ? selectedOption.symbol : '',
                                    }))
                                  }
                                  options={countryOptions}
                                  components={{ ClearIndicator }}
                                  isClearable
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                    control: base => ({ ...base, zIndex: 1 })
                                  }}
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Price</label>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="price"
                                  value={consultantDetails.price || ''}
                                  onChange={handleConsultantDetailsChange}
                                />
                              </div>
                              <div className="form-group col-md-4">
                                <label>Tax %</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="tax"
                                  value={consultantDetails.tax || ''}
                                  onChange={handleConsultantDetailsChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="col-lg-12 col-md-12">
                    <div className="container-fluid my-2 px-0">
                      <div className="row">
                        {uploadedFiles?.map((file, index) => (
                          <div key={index} className="col-6 mb-2">
                            <button
                              className="btn btn-link text-danger btn-action"
                              type="button"
                              onClick={() => handleDelete(index)}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </button>
                            <a
                              href="#"
                              onClick={() =>
                                window.open(
                                  URL.createObjectURL(file),
                                  "_blank"
                                )
                              }
                            >
                              {file.name}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <aside
            id="ud-sidebar"
            className={`ud-sidebar ${sidebarOpen ? "active" : ""}`}
          >
            <div
              id="dismissudsidebarCollapse"
              className="dismissudsidebar"
              onClick={toggleSidebar}
            >
              <i className="ri-close-circle-fill"></i>
            </div>
            <div class="sidebar-header">
              <h6 class="mb-0">Employee Payroll</h6>
            </div>
            <div class="scroll-area">
              <ul
                class="nav nav-pills tab-pills justify-content-center custom-pill mt-2"
                id="pills-tab"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    data-toggle="pill"
                    href="#payslips"
                    role="tab"
                    onClick={handleTabChange}
                  >
                    Payslip
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    data-toggle="pill"
                    href="#insurances"
                    role="tab"
                    onClick={handleTabChange}
                  >
                    Insurance
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    data-toggle="pill"
                    href="#taxdocs"
                    role="tab"
                    onClick={handleTabChange}
                  >
                    Tax
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    data-toggle="pill"
                    href="#advancePay"
                    role="tab"
                    onClick={handleTabChange}
                  >
                    Advance Pay
                  </a>
                </li>
              </ul>
              <div class="tab-content">
                <div
                  class="tab-pane fade show active"
                  id="payslips"
                  role="tabpanel"
                >
                  <form onSubmit={handleUpload}>
                    <div className="row justify-content-center mt-4">
                      <div className="col-lg-10 col-md-10">
                        <div className="form-group">
                          <div className="custom-file">
                            <input
                              type="file"
                              className="custom-file-input"
                              id="uploadEmpPayslip"
                              onChange={handleFileChange}
                            />
                            <label
                              className="custom-file-label"
                              htmlFor="uploadEmpPayslip"
                            >
                              {fileNames.uploadEmpPayslip ? fileNames.uploadEmpPayslip : "Select EmployeeId.PDF"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-10 col-md-10">
                        <div className="form-group">
                          <label htmlFor="selectMonthYear">
                            Month and Year
                          </label>
                          <DatePicker
                            selected={selectedDate}
                            onChange={(date) => setSelectedDate(date)}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            className="form-control form-control ml-5"
                            id="selectMonthYear"
                            style={{ marginLeft: "100px" }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-10 col-md-10">
                        <div className="container-fluid my-2 px-0">
                          <div className="row">
                            <div className="col-12 text-center"></div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-10 col-md-10 text-center">
                        <button
                          type="submit"
                          className="btn btn-secondary"
                          data-toggle="modal"
                          data-target="#successModal"
                        >
                          Upload <i className="ri-checkbox-circle-line"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                  <hr />

                  <div className="row">
                    <div className="col">
                      <h5 className="title mt-1 mb-0">Summary</h5>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        title="Email"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-mail-send-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Share"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-share-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Export"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-export-fill"></i>
                      </button>
                      <button
                        type="button"
                        id="filterBtn-show-1"
                        title="Filter"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-filter-2-fill"></i>
                      </button>
                    </div>
                  </div>

                  <div
                    className="row align-items-center justify-content-center mt-3"
                    id="filter-table-1"
                    style={{ display: "none" }}
                  >
                    <div className="col-lg-12 col-md-12 text-center">
                      <div
                        className="btn-group btn-group-toggle"
                        data-toggle="buttons"
                      >
                        <label className="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="payslipYear2024"
                            checked
                          />
                          2025
                        </label>
                        <label className="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="payslipYear2023"
                          />
                          2023
                        </label>
                        <label className="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="payslipYear2022"
                          />
                          2022
                        </label>
                        <label className="btn btn-outline-primary active">
                          <input
                            type="radio"
                            name="filterBy"
                            id="allpayslipYears"
                          />{" "}
                          View All
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="row mt-3">
                    <div className="col-md-12" id="employeePayslipList">
                      <h6
                        className="title accordion-title"
                        data-toggle="collapse"
                        data-target="#payslipYear2024-2025"
                      >
                        <i className="ri-calendar-2-line"></i> {selectedYear}
                        <span className="show-payslip-details float-right">
                          <div className="row">
                            <div className="col border-right">
                              <i className="ri-file-list-3-line"></i> Available
                              Payslips
                            </div>
                            <div className="col-auto">
                              <span className="text-success">
                                {" "}
                                {payslips.length}
                              </span>
                            </div>
                          </div>
                        </span>
                      </h6>
                      <div
                        className="collapse show"
                        id={`payslipYear${selectedYear}-details`}
                        data-parent="#employeePayslipList"
                      >
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div className="table-responsive leave-information">
                              <table className="table grid">
                                <thead className="bg-light">
                                  <tr>
                                    <th>S.No.</th>
                                    <th>
                                      Files{" "}

                                    </th>
                                    <th>
                                      Uploaded Date{" "}

                                    </th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {documents?.map((payslip, index) => {
                                    const pathParts = payslip.Path.split("/");

                                    console.log("Path Parts:", pathParts); // Debugging

                                    // Extract month and year based on correct indices
                                    const year = pathParts[pathParts.length - 2]; // Extract '2025'
                                    const monthName = pathParts[pathParts.length - 3]; // Extract 'march'

                                    // Capitalize the first letter of the month name
                                    const formattedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1);

                                    const fileName = `${year}${formattedMonth}`; // Expected Output: 'March2025'

                                    console.log("Formatted File Name:", fileName); // Debugging

                                    const uploadDate = new Date(payslip.UploadTime);
                                    const formattedUploadDate = uploadDate.toISOString().split("T")[0];

                                    return (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{fileName}</td>
                                        <td>{formattedUploadDate}</td>
                                        <td className="text-center">
                                          <a
                                            href={payslip.Path}
                                            className="btn btn-link text-info btn-action"
                                            title="View"
                                            rel="tooltip"
                                            target="_blank"
                                          >
                                            <i className="ri-eye-line"></i>
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="insurances" role="tabpanel">
                  <div class="row justify-content-center mt-3">
                    <div class="col-lg-10 col-md-10">
                      <div class="form-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="uploadEmpInsurance"
                            onChange={handleFileChange}
                          />
                          <label
                            class="custom-file-label"
                            for="uploadEmpInsurance"
                          >
                            {fileNames.uploadEmpInsurance ? fileNames.uploadEmpInsurance : "Select EmployeeId.PDF"}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-10 col-md-10">
                      <div className="form-group">
                        <label htmlFor="selectMonthYear">Month and Year</label>
                        <DatePicker
                          selected={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          className="form-control form-control ml-4"
                          id="selectMonthYear"
                          style={{ marginLeft: "100px" }}
                        />
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-10">
                      <div class="container-fluid my-2 px-0">
                        <div class="row">
                          <div class="col-12 text-center"></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-10 text-center">
                      <button
                        type="submit"
                        class="btn btn-secondary"
                        data-toggle="modal"
                        data-target="#successModal"
                        onClick={handleUploadInsurance}
                      >
                        Upload <i class="ri-checkbox-circle-line"></i>
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col">
                      <h5 class="title mt-1 mb-0">Summary</h5>
                    </div>
                    <div class="col-auto">
                      <button
                        type="button"
                        title="Email"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-mail-send-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Share"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-share-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Export"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-export-fill"></i>
                      </button>
                      <button
                        type="button"
                        id="filterBtn-show-2"
                        title="Filter"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-filter-2-fill"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-center mt-3"
                    id="filter-table-2"
                    style={{ display: "none" }}
                  >
                    <div class="col-lg-12 col-md-12 text-center">
                      <div
                        class="btn-group btn-group-toggle"
                        data-toggle="buttons"
                      >
                        <label class="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYear2024"
                            checked
                          />
                          2025
                        </label>
                        <label class="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYear2023"
                          />
                          2023
                        </label>
                        <label class="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYear2022"
                          />
                          2022
                        </label>
                        <label class="btn btn-outline-primary active">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYears"
                          />{" "}
                          View All
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-12" id="employeeInsuranceList">
                      <h6
                        className="title accordion-title"
                        data-toggle="collapse"
                        data-target={`#year${currentYear}-${currentYear + 1}`}
                      >
                        <i className="ri-calendar-2-line"></i> {currentYear}
                        <span className="show-payslip-details float-right">
                          <div className="row">
                            <div className="col border-right">
                              <i className="ri-shield-user-line"></i> Available
                              Insurances
                            </div>
                            <div className="col-auto">
                              <span className="text-success">
                                {" "}
                                {availableInsuranceCount}
                              </span>
                            </div>
                          </div>
                        </span>
                      </h6>

                      <div
                        class="collapse show"
                        id="year2024-2025"
                        data-parent="#employeeInsuranceList"
                      >
                        <div class="row mt-3">
                          <div class="col-md-12">
                            <div class="table-responsive leave-information">
                              <table class="table grid">
                                <thead class="bg-light">
                                  <tr>
                                    <th>S.No.</th>
                                    <th>
                                      Files

                                    </th>
                                    <th>
                                      Uploaded Date

                                    </th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {insDocuments?.map((document, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      {/* <td>
                                        {document.DocumentURL.split("/").pop()}
                                      </td> */}
                                      <td>
                                        {document.DocumentURL
                                          ? document.DocumentURL.split('?')[0].split('/').pop()
                                          : "No Document"}
                                      </td>

                                      <td>
                                        {formatDate(document.UploadedTime)}
                                      </td>
                                      <td className="text-center">
                                        <span>
                                          <a
                                            href={document.DocumentURL}
                                            target="_blank" // This opens the link in a new tab
                                            className="btn btn-link text-info btn-action"
                                            title="View"
                                            rel="noopener noreferrer"
                                          >
                                            <i className="ri-eye-line"></i>
                                          </a>
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane fade" id="taxdocs" role="tabpanel">
                  <div class="row justify-content-center mt-3">
                    <div class="col-lg-10 col-md-10">
                      <div class="form-group">
                        <div class="custom-file">
                          <input
                            type="file"
                            class="custom-file-input"
                            id="uploadEmpInsurance"
                            onChange={handleFileChange}
                          />
                          <label
                            class="custom-file-label"
                            for="uploadEmpInsurance"
                          >
                            {fileNames.uploadEmpInsurance ? fileNames.uploadEmpInsurance : "Select EmployeeId.PDF"}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-10 col-md-10">
                      <div className="form-group">
                        <label htmlFor="selectMonthYear">Month and Year</label>
                        <DatePicker
                          selected={selectedDate}
                          onChange={(date) => setSelectedDate(date)}
                          dateFormat="MM/yyyy"
                          showMonthYearPicker
                          className="form-control form-control ml-4"
                          id="selectMonthYear"
                          style={{ marginLeft: "100px" }}
                        />
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-10">
                      <div class="container-fluid my-2 px-0">
                        <div class="row">
                          <div class="col-12 text-center"></div>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-10 col-md-10 text-center">
                      <button
                        type="submit"
                        class="btn btn-secondary"
                        data-toggle="modal"
                        data-target="#successModal"
                        onClick={handleUploadTax}
                      >
                        Upload <i class="ri-checkbox-circle-line"></i>
                      </button>
                    </div>
                  </div>
                  <hr />

                  <div class="row">
                    <div class="col">
                      <h5 class="title mt-1 mb-0">Summary</h5>
                    </div>
                    <div class="col-auto">
                      <button
                        type="button"
                        title="Email"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-mail-send-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Share"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-share-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Export"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-export-fill"></i>
                      </button>
                      <button
                        type="button"
                        id="filterBtn-show-2"
                        title="Filter"
                        rel="tooltip"
                        class="btn btn-light btn-circle ml-2"
                      >
                        <i class="ri-filter-2-fill"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    class="row align-items-center justify-content-center mt-3"
                    id="filter-table-2"
                    style={{ display: "none" }}
                  >
                    <div class="col-lg-12 col-md-12 text-center">
                      <div
                        class="btn-group btn-group-toggle"
                        data-toggle="buttons"
                      >
                        <label class="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYear2024"
                            checked
                          />
                          2025
                        </label>
                        <label class="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYear2023"
                          />
                          2023
                        </label>
                        <label class="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYear2022"
                          />
                          2022
                        </label>
                        <label class="btn btn-outline-primary active">
                          <input
                            type="radio"
                            name="filterBy"
                            id="insuranceYears"
                          />{" "}
                          View All
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-12" id="employeeInsuranceList">
                      <h6
                        className="title accordion-title"
                        data-toggle="collapse"
                        data-target={`#year${currentYear}-${currentYear + 1}`}
                      >
                        <i className="ri-calendar-2-line"></i> {currentYear}
                        <span className="show-payslip-details float-right">
                          <div className="row">
                            <div className="col border-right">
                              <i className="ri-shield-user-line"></i> Available
                              Insurances
                            </div>
                            <div className="col-auto">
                              <span className="text-success">
                                {" "}
                                {availableTaxuranceCount}
                              </span>
                            </div>
                          </div>
                        </span>
                      </h6>
                      <div
                        class="collapse show"
                        id="year2024-2025"
                        data-parent="#employeeInsuranceList"
                      >
                        <div class="row mt-3">
                          <div class="col-md-12">
                            <div class="table-responsive leave-information">
                              <table class="table grid">
                                <thead class="bg-light">
                                  <tr>
                                    <th>S.No.</th>
                                    <th>
                                      Files

                                    </th>
                                    <th>
                                      Uploaded Date

                                    </th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {taxDocuments?.map((document, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      {/* <td>
                                        {document.DocumentURL.split("/").pop()}
                                      </td> */}
                                      <td>
                                        {document.DocumentURL
                                          ? document.DocumentURL.split('?')[0].split('/').pop()
                                          : "No Document"}
                                      </td>

                                      <td>
                                        {formatDate(document.UploadedTime)}
                                      </td>
                                      <td className="text-center">
                                        <span>
                                          <a
                                            href={document.DocumentURL}
                                            className="btn btn-link text-info btn-action"
                                            title="View"
                                            rel="tooltip"
                                          >
                                            <i className="ri-eye-line"></i>
                                          </a>
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-pane fade" id="advancePay" role="tabpanel">
                  <div className="row mt-4 justify-content-center">
                    <div className="col-lg-11 col-md-11">
                      {pendingRequests?.map((request) => (
                        <div
                          key={request.employeeId}
                          className="card mb-2 border border-warning"
                        >
                          <div className="card-body">
                            <div className="d-flex align-items-top justify-content-between">
                              <div>
                                <span className="badge border border-warning text-warning status">
                                  <i className="ri-hourglass-fill"></i> Pending
                                </span>
                              </div>
                              <div className="position-relative">
                                <button
                                  className="btn btn-link text-info btn-action custom-dropdown-btn dropdown-toggle"
                                  type="button"
                                  title="Update"
                                  data-target={`updateRequest-${request.employeeId}`}
                                  data-toggle="dropdown"
                                  rel="tooltip"
                                >
                                  <i className="ri-list-settings-line"></i>
                                </button>
                                <div
                                  id={`updateRequest-${request.employeeId}`}
                                  className="dropdown-menu dropdown dropdown-menu-right custom-dropdown sidebar-dropdown shadow"
                                >
                                  <div className="row drop-down-scroll">
                                    <div className="form-group col-6">
                                      <div className="form-check">
                                        <input
                                          type="radio"
                                          className="form-check-input custom-radio"
                                          name={`updateRequest-${request.employeeId}`}
                                          id={`notifyApprove-${request.employeeId}`}
                                          value="Approved"
                                          onChange={() => setStatus("Approved")}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`notifyApprove-${request.employeeId}`}
                                          onClick={(e) => e.stopPropagation()} // Prevents dropdown closure if it's inside one
                                        >
                                          Approve
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-group col-6">
                                      <div className="form-check">
                                        <input
                                          type="radio"
                                          className="form-check-input custom-radio"
                                          name={`updateRequest-${request.employeeId}`}
                                          id={`notifyReject-${request.employeeId}`}
                                          value="Rejected"
                                          onChange={() => setStatus("Rejected")}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`notifyReject-${request.employeeId}`}
                                          onClick={(e) => e.stopPropagation()} // Prevents dropdown closure if it's inside one
                                        >
                                          Reject
                                        </label>
                                      </div>
                                    </div>
                                    <div className="form-group col-12">
                                      <label htmlFor={`notifyComment-${request.employeeId}`}>
                                        Comment <small>(If Reject)</small>
                                      </label>
                                      <textarea
                                        className="form-control"
                                        rows="3"
                                        id={`notifyComment-${request.employeeId}`}
                                        onChange={(e) => setComments(e.target.value)}
                                        disabled={status !== "Rejected"}
                                      ></textarea>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12 text-center">
                                      <button
                                        type="reset"
                                        className="btn btn-light"
                                        onClick={handlePayslipCancel}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={(e) => handleUpdate(request)}
                                      >
                                        Update{" "}
                                        <i className="ri-checkbox-circle-line"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <h5 className="title mb-2">
                              Amount: {request.amount}
                            </h5>
                            <small className="text-muted">
                              Request Date:{" "}
                              {moment(request.requestedDate).format(
                                "DD-MM-YYYY"
                              )}
                            </small>
                            <p className="mb-0">{request.description}</p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <hr />
                  <div className="row mt-2">
                    <div className="col">
                      <h5 className="title mt-1 mb-0">Summary</h5>
                    </div>
                    <div className="col-auto">
                      <button
                        type="button"
                        title="Email"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-mail-send-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Share"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-share-fill"></i>
                      </button>
                      <button
                        type="button"
                        title="Export"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-export-fill"></i>
                      </button>
                      <button
                        type="button"
                        id="filterBtn-show-3"
                        title="Filter"
                        rel="tooltip"
                        className="btn btn-light btn-circle ml-2"
                      >
                        <i className="ri-filter-2-fill"></i>
                      </button>
                    </div>
                  </div>
                  <div
                    className="row align-items-center justify-content-center mt-3"
                    id="filter-table-3"
                    style={{ display: "none" }}
                  >
                    <div className="col-lg-12 col-md-12 text-center">
                      <div
                        className="btn-group btn-group-toggle"
                        data-toggle="buttons"
                      >
                        <label className="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="payslipYear2024"
                            defaultChecked
                          />
                          2025
                        </label>
                        <label className="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="payslipYear2023"
                          />
                          2023
                        </label>
                        <label className="btn btn-outline-primary">
                          <input
                            type="radio"
                            name="filterBy"
                            id="payslipYear2022"
                          />
                          2022
                        </label>
                        <label className="btn btn-outline-primary active">
                          <input
                            type="radio"
                            name="filterBy"
                            id="allpayslipYears"
                          />{" "}
                          View All
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12" id="employeePayslipList">
                      <h6
                        className="title accordion-title"
                        data-toggle="collapse"
                        data-target="#payslipYear2024-2025"
                      >
                        <i className="ri-calendar-2-line"></i> 2025
                        <span className="show-payslip-details float-right">
                          <div className="row">
                            <div className="col border-right">
                              <i className="ri-cash-line"></i> Available
                              Requests
                            </div>
                            <div className="col-auto">
                              <span className="text-success">
                                {" "}
                                {advanceRequests.length}
                              </span>
                            </div>
                          </div>
                        </span>
                      </h6>
                      <div
                        className="collapse show"
                        id="payslipYear2024-2025"
                        data-parent="#employeePayslipList"
                      >
                        <div className="row mt-3">
                          <div className="col-md-12">
                            <div className="table-responsive leave-information">
                              <table className="table grid">
                                <thead className="bg-light">
                                  <tr>
                                    <th>S.No.</th>
                                    <th>
                                      Amount{" "}

                                    </th>
                                    <th>
                                      Request Date{" "}

                                    </th>
                                    <th>Status</th>
                                    {/* <th>Comments</th> */}
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {advanceRequests?.map((request, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td className="text-right">
                                        {request.amount}
                                      </td>
                                      <td>
                                        {moment(request.requestedDate).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </td>
                                      <td>
                                        <span
                                          className={`badge border ${request.status === "Pending"
                                            ? "border-warning text-warning"
                                            : request.status === "Approved"
                                              ? "border-success text-success"
                                              : "border-light text-light"
                                            } status`}
                                        >
                                          {request.status === "Pending" && (
                                            <i className="ri-hourglass-fill"></i>
                                          )}
                                          {request.status === "Approved" && (
                                            <i className="ri-thumb-up-fill"></i>
                                          )}
                                          {request.status === "Rejected" && (
                                            <i className="ri-thumb-down-line"></i>
                                          )}
                                          {request.status}
                                        </span>
                                      </td>
                                      {/* <td>{request.comments}</td> */}
                                      <td className="text-center">
                                        <button
                                          className="btn btn-link text-info btn-action custom-dropdown-btn"
                                          type="button"
                                          title="Download"
                                          rel="tooltip"
                                        >
                                          <i className="ri-download-2-line"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
      <div class="row fixed-footer">
        <div class="col-lg-12 text-center">
          <button class="btn btn-light" type="reset" onClick={handleCancel}>
            Cancel
          </button>
          <button class="btn btn-primary" type="button" onClick={handleSubmit}>
            Submit <i class="ri-checkbox-circle-line"></i>
          </button>
        </div>
      </div>
      {showWelcomeKitModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Update Welcome Kit</h5>
                <button
                  type="button"
                  className="close"
                  onClick={handleWelcomeKitModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body p-3">
                <UpdateWelcomeKit
                  employeeId={employeeId}
                  isModal={true}
                  onClose={handleWelcomeKitModal}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeUpdate;
